import type { AuthStore } from '@stores/auth/interfaces'

import { lsAccessToken, lsRefreshToken, lsExpiresAt } from './storage'

export const _clearTokens = (state: AuthStore): void => {
  state.accessToken   = ''
  state.refreshToken  = ''
  state.expiresAt     = 0

  lsAccessToken.value   = ''
  lsRefreshToken.value  = ''
  lsExpiresAt.value     = 0
}
